export const trimText = (text, limit) => {
  if (text.length > limit) {
    const splitArr = text.split("");
    text = splitArr.slice(0, limit).join("") + "...";
  }
  return text;
};
